import AsciiTable from 'ascii-table'

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function emailBody(sae, type, aeTreatments = []) {
  
  var treatmentsStr = ''

  if (aeTreatments && aeTreatments.length) {
    var table = new AsciiTable('Case assessment - ' + aeTreatments[0].adverse_event_id)
    table.setHeading('Drug', 'Investigator Relationship', 'Last Sponsor relationship', 'Expectedness')
      
    aeTreatments.forEach(el => {
      table.addRow(el.treatment.drug , el.relationship, el.relationship_sponsor, (el.expectedness ? 'Expected' : (el.expectedness == 0 ? 'Not Expected' : '')))
    })

    var treatmentsStr = table.toString()
  }

  let armsStr = ''
  if(sae.arms) {
    armsStr = `Arm: ${sae.arms}`
  }
  
  const body = {
    'Company': `
Dear all, 

please find attached the SAE report as detailed below.

Patient ID: ${sae.patient_id}
AE verbatim reported: ${sae.ae_verbatim_reported}
AE onset date: ${sae.ae_onset_date}
Case type: ${sae.case_type}
Case identification number: ${sae.cin}
${armsStr}

We remain at your disposal for any issue. 

Best regards, 
Pharmacovigilance Office`,
      
    'Medical Monitor': `
Dear medical monitor,

please find attached the SAE report as detailed below 

Case identification number: ${sae.cin}
Patient ID: ${sae.patient_id}
AE verbatim reported: ${sae.ae_verbatim_reported}
AE onset date: ${sae.ae_onset_date}

${treatmentsStr}

Please report your consideration about study drug relationship to the event and expectedness (expected/not expected)
in case the event is considered related to study drugs. 

In case further clarification on the case is needed do not hesitate to contact Pharmacovigilance Office.

Thank you for your kind collaboration.

Best regards,
Pharmacovigilance Office

--
Only for SafetyDB registered users <a href="${window.location.href}" target="blank">click here</a>`,



  };
  
  return body[type];
}


export function emailSubject(sae, type) {
  const subject = {
    'Company': `Protocol ${sae.protocol.name}_{Protocol Company Code}_SAE Patient ${sae.patient_id}_${sae.ae_verbatim_reported}_${sae.case_type}`,
    'Medical Monitor': `Protocol ${sae.protocol.name}_MEDICAL ASSESSMENT_SAE Patient ${sae.patient_id}_${sae.ae_verbatim_reported}_${sae.case_type}`
  };
  return subject[type];
}
